import { render, staticRenderFns } from "./CompanyMenu.vue?vue&type=template&id=fd0f65c0&scoped=true&"
import script from "./CompanyMenu.vue?vue&type=script&lang=js&"
export * from "./CompanyMenu.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMenu.vue?vue&type=style&index=0&id=fd0f65c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0f65c0",
  null
  
)

export default component.exports